import { __styles } from '@griffel/react';
import { createWrapper } from '../wrapper';
import { typographyStyles } from '@fluentui/react-theme';
export const caption1ClassNames = {
  root: 'fui-Caption1'
};
/**
 * Styles for the root slot
 */

const useStyles = /*#__PURE__*/__styles({
  "root": {
    "Bahqtrf": "fk6fouc",
    "Be2twd7": "fy9rknc",
    "Bhrd7zp": "figsok6",
    "Bg96gwp": "fwrc4pm"
  }
}, {
  "d": [".fk6fouc{font-family:var(--fontFamilyBase);}", ".fy9rknc{font-size:var(--fontSizeBase200);}", ".figsok6{font-weight:var(--fontWeightRegular);}", ".fwrc4pm{line-height:var(--lineHeightBase200);}"]
});
/**
 * Text wrapper component for the Caption1 typography variant
 */


export const Caption1 = /*#__PURE__*/createWrapper({
  useStyles,
  className: caption1ClassNames.root,
  displayName: 'Caption1'
});
//# sourceMappingURL=Caption1.js.map